import { ReactWebComponent } from '@app/utils/web-components';
import { lazy } from 'react';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const AppSidebar = lazy(() => import('../AppSidebar/AppSidebar'));

class AppSidebarWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['show-quick-start-button', 'show-chat-button', 'project-id', 'is-style-guide-enabled'];
    }

    render() {
        const showQuickStartButton = this.prop('show-quick-start-button') === 'true';
        const showChatButton = this.prop('show-chat-button') === 'true';
        const projectId = this.prop('project-id');
        const isStyleGuideEnabled = this.prop('is-style-guide-enabled') === '1';

        return (
            <RootProviders>
                <AppSidebar
                    showQuickStartButton={showQuickStartButton}
                    projectId={projectId}
                    showChatButton={showChatButton}
                    isStyleGuideFeatureEnabled={isStyleGuideEnabled}
                />
            </RootProviders>
        );
    }
}

customElements.define('app-sidebar', AppSidebarWebComponent);
